// import effects here
import { IrGeneratorEffects } from '@ps/ai-assistant-data-access';
import { AuthEffects } from '@ps/auth-data-access';
import { SurveyEffects } from '@ps/survey-data-access';

// add effect in this export
export const STORE_EFFECTS = [IrGeneratorEffects, AuthEffects, SurveyEffects];
